import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { useT } from '../../i18n';

/**
 * La fenêtre dans laquelle une liste d'adresses se lit.
 *
 * Elle s'ouvre au-dessus du formulaire parce que c'est un document — on le
 * lit, on l'exporte, on revient. Une seule implémentation, pour le
 * comportement qui n'est pas évident : le formulaire se ferme aussi sur Échap,
 * et il ne doit pas partir sous celle-ci. Recopié dans chaque panneau, ce
 * détail-là serait celui qu'on oublie.
 */
const EmailPanelDialog = ({ title, testId, onClose, children }) => {
  const t = useT();

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      event.stopPropagation();
      onClose();
    };
    window.addEventListener('keydown', onKeyDown, true);
    return () => window.removeEventListener('keydown', onKeyDown, true);
  }, [onClose]);

  return (
    <div className="modal-overlay" style={{ zIndex: 60 }} onClick={onClose} role="presentation">
      <div
        className="modal-content"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        data-testid={`${testId}-dialog`}
      >
        <div className="p-6 space-y-4">
          <div className="flex items-start justify-between gap-4">
            <h3 className="text-lg font-semibold">{title}</h3>
            <button
              type="button"
              onClick={onClose}
              className="btn-ghost h-8 w-8 p-0 flex-shrink-0"
              aria-label={t('operations.close')}
              data-testid={`${testId}-close`}
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default EmailPanelDialog;
